import actions from './actions'

export type TBreadcrumbState = {
  map: Map<string, string>
}

// const STORED_STATE = (initialState: TBreadcrumbState): TBreadcrumbState => {
//   return initialState
// }

const initialState: TBreadcrumbState = {
  map: new Map([]),
}

export default function breadcrumbReducer(state: TBreadcrumbState = initialState, action: any) {
  switch (action.type) {
    case actions.ADD_ITEM:
      return {
        ...state,
        ...action.payload,
      }
    case actions.SET_STATE:
      return {
        ...state,
        ...action.payload,
      }
    case actions.GET_STATE:
      return state
    default:
      return state
  }
}
